module.exports = __webpack_public_path__ + "fonts/DM_Sans-500-latin4.c15d94a.woff2";